import React from "react";
import PropTypes from "prop-types";
import { CardContent, CardHeader, Grid, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { chartColors } from "common/constant";
import { pick } from "lodash";
import { withTranslation } from "react-i18next";

const NumberOfComplaintsBarChart = ({
  labels,
  series,
  setComplaintTitle,
  setComplaintTitleIndex,
  t,
}) => {
  const initialOption = {
    chart: {
      height: 350,
      type: "bar",
      stacked: true,
      events: {
        click: (_, __, config) => {
          const id =
            config?.globals?.selectedDataPoints?.[0]?.[0] ??
            config?.globals?.selectedDataPoints?.[1]?.[0];
          setComplaintTitle((prev) => labels[id] ?? prev);
          setComplaintTitleIndex((prev) => id ?? prev);
        },
      },
    },
    dataLabels: {
      enabled: true,
    },
    xaxis: {
      categories: labels,
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: "12px",
              fontWeight: 900,
            },
          },
        },
      },
    },
    legend: {
      onItemHover: {
        highlightDataSeries: false,
      },
      formatter: (seriesName, opts) => {
        const total = opts.w.globals.series[opts.seriesIndex].reduce(
          (acc, curr) => acc + curr,
          0
        );
        return [seriesName, " - ", total];
      },
    },
    colors: chartColors,
  };
  const filteredSeries = pick(series, [
    "Pending complaint of previous quarter",
    "Complaints received during the quarter",
  ]);
  const seriesData = Object.entries(filteredSeries).map(([key, value]) => ({
    name: key,
    data: value,
  }));

  return (
    <>
      <CardHeader
        title={
          <Grid container>
            <Grid item xs={8}>
              <Typography variant="subtitle1" fontWeight={700}>
                {t("Number of Complaints")}
              </Typography>
            </Grid>
          </Grid>
        }
      />
      <CardContent>
        <ReactApexChart
          options={initialOption}
          series={seriesData}
          type="bar"
          height={470}
        />
      </CardContent>
    </>
  );
};

NumberOfComplaintsBarChart.propTypes = {
  labels: PropTypes.array,
  series: PropTypes.object,
  setComplaintTitle: PropTypes.func,
  setComplaintTitleIndex: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation()(NumberOfComplaintsBarChart);
